module.exports = __webpack_public_path__ + "prod/1.42.2/img/house-platform.8ae5bfd3.png";